import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import "../../assets/style/BranchForm.css"; // Updated CSS file with USWDS grid
import {
  CustomSelect,
  getData,
  postData,
} from "../Commonfunction/CommonFunction";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

// Validation schema using Yup
const validationSchema = Yup.object().shape({
  department_name: Yup.string().required("Department name  is required"),
});

const DepartmentForm = ({ onClose, id, fetchData }) => {
  const [singleData, setSingleData] = useState();
  const navigate = useNavigate();
  const singleDepartmentData = async () => {
    try {
      const result = await getData(`/api/get-department/${id}`);
      if (result.success) {
        setSingleData(result.data);
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      console.log("Error: ", error);
    }
  };
  const handleSubmit = async (values) => {
    try {
      const request_url = id
        ? `/api/update-department/${id}`
        : "/api/create-department";
      const postDataResult = await postData(request_url, values);

      toast.success(postDataResult?.message);
      // postDataResult?.success === true && navigate("/master/department");
      onClose();
      // fetchData();
    } catch (error) {
      // Handle error
      toast.error(error.response.data.message);
    }
  };

  useEffect(() => {
    id && singleDepartmentData();
  }, [id]);
  return (
    <>
      <Formik
        enableReinitialize
        initialValues={{
          department_name: id ? singleData?.department_name : "",
        }}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          handleSubmit(values);
        }}
      >
        {({ errors, touched }) => (
          <Form>
            <div className="form-body">
              <div className="grid-row">
                <div className="grid-col-12">
                  <div className="form-group">
                    <label htmlFor="department_name">Department Name</label>
                    <Field
                      id="department_name"
                      name="department_name"
                      type="text"
                      placeholder="Enter Department name"
                      className={
                        errors.department_name && touched.department_name
                          ? "input-error"
                          : ""
                      }
                    />
                    <ErrorMessage
                      name="department_name"
                      component="div"
                      className="error-message"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="form-footer">
              <button
                type="button"
                className="btn btn-cancel"
                onClick={onClose}
              >
                Cancel
              </button>
              <button type="submit" className="btn btn-submit">
                Submit
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default DepartmentForm;
